import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Card } from '@/shared/components/ui/card'
import { routes } from '@/shared/constants'
import { useMyOrganization } from '@/features/organization/hooks/useMyOrganization'
import { AdditionalBusinessWizard } from './components/create-wizard/AdditionalBusinessWizard'

/**
 * Página `/app/businesses/new`. Usa el wizard unificado `AdditionalBusinessWizard`
 * tanto para el primer negocio (sin org) como para negocios adicionales.
 *
 * - Sin org (`firstTime`): crea org + primer negocio, refresca el JWT y navega
 *   al detalle de la organización.
 * - Con org: crea un negocio adicional sin cambiar el rol ni el token.
 */
export function CreateBusinessPage() {
  const navigate = useNavigate()
  const { organization, loading: orgLoading } = useMyOrganization()
  const goBack = () => navigate(routes.app.businesses.list)
  const firstTime = !organization

  if (orgLoading && !organization) {
    return (
      <div className="space-y-6">
        <div className="h-6 w-32 animate-pulse rounded bg-surface" />
        <Card>
          <div className="h-64 animate-pulse rounded bg-surface" />
        </Card>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <header>
        <button
          type="button"
          onClick={goBack}
          className="inline-flex items-center gap-1.5 text-sm text-ink-muted hover:text-ink"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver a Mis negocios
        </button>
        <h1 className="mt-2 font-serif text-[36px] font-normal leading-[1.1] tracking-tight text-ink">
          {firstTime ? 'Crear mi organización y primer negocio' : 'Crear negocio'}
        </h1>
        <p className="mt-1 text-sm text-ink-muted">
          {firstTime
            ? 'Como aún no tienes organización, crearemos primero la organización y luego tu primer negocio.'
            : 'Registra una nueva unidad de negocio dentro de tu organización.'}
        </p>
      </header>

      <Card>
        <AdditionalBusinessWizard onCancel={goBack} firstTime={firstTime} />
      </Card>
    </div>
  )
}
